import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import axios from "../../api/axiosClient";
import { useLoading } from "../../components/LoadingContext";
import Grid from "@mui/material/Grid";
import { Typography, FormLabel, Button, Box } from "@mui/material";
import CustomInput from "../../components/ui/CustomInput";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import IconButton from "@mui/material/IconButton";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import { handleError, errorToast, dataURLtoFile } from "../../services/serviceBase";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import QCDataHeader from "../../components/ui/QC/QCDataHeader";
import { Buffer } from "buffer";
import { useSelector, useDispatch} from "react-redux";
import 'react-html5-camera-photo/build/css/index.css';
import ShootPhoto from "../../components/ui/ShootPhoto";
import { setBackFromDefect } from "../../redux/qcSlice";

export default function QCDefect() {
  const intl = useIntl();
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const { idReturnFileHead, idArticle, idQualityCheck, idDefectForQC } = params;
  const isEdit = useSelector((state) => state.qc.isEdit);
  const boxBarcode = useSelector((state) => state.qc.boxBarcode);

  const [locationLevelDefects, setLocationLevelDefects] = useState([]);
  const [location, setLocation] = useState("");
  const [sublocationLevelDefects, setSublocationLevelDefects] = useState([]);
  const [sublocation, setSublocation] = useState("");
  const [problemLevelDefects, setProblemLevelDefects] = useState([]);
  const [problem, setProblem] = useState("");
  const [responsibilityLevelDefects, setResponsibilityLevelDefects] = useState([]);
  const [responsibility, setResponsibility] = useState("");
  const [note, setNote] = useState("");
  const [existingNote, setExistingNote] = useState("");
  const [barcode, setBarcode] = useState("");
  const [returnFileByArticle, setReturnFileByArticle] = useState("");
  const [sketch, setSketch] = useState("");
  const [uploadImages, setUploadImages] = useState([]);

  const [existingLocation, setExistingLocation] = useState("");
  const [existingSublocation, setExistingSublocation] = useState("");
  const [existingProblem, setExistingProblem] = useState("");
  const [existingResponsibility, setExistingResponsibility] = useState("");
  const [existingAttach, setExistingAttach] = useState([]);
  const [renderAttach, setRenderAttach] = useState([]);

  const [showTakePhoto, setShowTakePhoto] = useState(false);

  const [imageMaxHeigth, setImageMaxHeigth] = useState(600);

  const resizeTable = () => {
    var pageHeight = window.innerHeight;
    var height = (pageHeight / 100) * 65;
    setImageMaxHeigth(height);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  useEffect(() => {
    resizeTable();
  });

  useEffect(() => {
    GetReturnFileByArticle();
    if (idDefectForQC != null) {
      getExistingDefect();
    }
  }, []);

  useEffect(() => {
    if (returnFileByArticle?.articleInfo != undefined) {
      setBarcode(returnFileByArticle?.articleInfo.barcode);
    }
  }, [returnFileByArticle]);

  useEffect(() => {
    if (barcode.length != 0) {
      getLocationLevelDefects();
      GetSketch();
    }
  }, [barcode]);

  useEffect(() => {
    getSublocLevelDefects();
  }, [location, barcode]);

  useEffect(() => {
    getProblemLevelDefects();
  }, [sublocation, barcode]);

  useEffect(() => {
    getRespLevelDefects();
  }, [problem, barcode]);

  useEffect(() => {
    if (location.length == 0) {
      setSublocation("");
      setProblem("");
      setResponsibility("");
    }
    if (sublocation.length == 0) {
      setProblem("");
      setResponsibility("");
    }
  }, [location, sublocation, problem]);

  useEffect(() => {
    if(existingAttach.length != 0 && existingAttach.length != renderAttach.length){
      const promises = existingAttach.map(x => getExistingDefectThumbnail(x));
      Promise.all(promises).then(images => {
        setLoading(false);
        setRenderAttach(images);
      });
    }
  }, [existingAttach]);

  const getLocationLevelDefects = () => {
    setLoading(true);
    const params = new URLSearchParams([]);
    params.append("barcode", barcode);
    params.append("findRoots", true);
    axios
      .get("/qualitycheck/defectattributes", { params })
      .then((response) => {
        setLoading(false);
        var selectLocations = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            selectLocations.push({
              value: x.idAttribute,
              text: x.attributeName,
            });
          });
        }
        setLocationLevelDefects(selectLocations);

        if (existingLocation.length != 0) {
          setLocation(existingLocation);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getSublocLevelDefects = () => {
    setLoading(true);
    const params = new URLSearchParams([]);
    params.append("barcode", barcode);
    params.append("idParent", location);
    params.append("findRoots", false);
    axios
      .get("/qualitycheck/defectattributes", { params })
      .then((response) => {
        setLoading(false);
        var selectSublocations = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            selectSublocations.push({
              value: x.idAttribute,
              text: x.attributeName,
            });
          });
        }
        setSublocationLevelDefects(selectSublocations);

        if (existingSublocation.length != 0) {
          setSublocation(existingSublocation);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getProblemLevelDefects = () => {
    setLoading(true);
    const params = new URLSearchParams([]);
    params.append("barcode", barcode);
    params.append("idParent", sublocation);
    params.append("findRoots", false);
    axios
      .get("/qualitycheck/defectattributes", { params })
      .then((response) => {
        setLoading(false);
        var selectProblems = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            selectProblems.push({
              value: x.idAttribute,
              text: x.attributeName,
            });
          });
        }
        setProblemLevelDefects(selectProblems);

        if (existingProblem.length != 0) {
          setProblem(existingProblem);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getRespLevelDefects = () => {
    setLoading(true);
    const params = new URLSearchParams([]);
    params.append("barcode", barcode);
    params.append("idParent", problem);
    params.append("findRoots", false);
    axios
      .get("/qualitycheck/defectattributes", { params })
      .then((response) => {
        setLoading(false);
        var selectResp = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            selectResp.push({
              value: x.idAttribute,
              text: x.attributeName,
            });
          });
        }
        setResponsibilityLevelDefects(selectResp);

        var store = selectResp.find((x) => x.text == "Store");
        if(store) {
          setResponsibility(store.value);
        }

        if (existingResponsibility.length != 0) {
          setResponsibility(existingResponsibility);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleSaveDefect = () => {
    setLoading(true);
    let data = {
      idAttribute: responsibility,
      notes: note,
    };

    axios
      .post("/qualitycheck/" + idQualityCheck + "/defects", data)
      .then((response) => {
        setLoading(false);
        var files = uploadImages;
        if (files.length != 0) {
          files.map((file) => {
            handleUploadPhoto(response.data, file);
          });
        } else {
          toast.success("Saved!");
          navigateToQcItem();
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleUploadPhoto = (idQCDefect, file) => {
    setLoading(true);
    const data = new FormData();
    data.append("file", file);
    var url = `/qualitycheck/${idQualityCheck}/defects/${idQCDefect}/attachments`;
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        toast.success("Saved!");
        navigateToQcItem();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const GetReturnFileByArticle = () => {
    setLoading(true);
    var url = "returnfiles/" + idReturnFileHead + "/" + idArticle;
    axios
      .get(url)
      .then((response) => {
        setLoading(false);
        if (
          response != null &&
          response != undefined &&
          response.data !== null &&
          response.data !== undefined
        ) {
          setReturnFileByArticle(response.data);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const GetSketch = () => {
    setLoading(true);
    axios
      .get("/qualitycheck/Sketches/" + barcode, { responseType: "arraybuffer" })
      .then((response) => {
        setLoading(false);
        var base64 = Buffer.from(response.data).toString("base64");
        setSketch(base64);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const onSelectFile = (e) => {
    setUploadImages([...uploadImages, e.target.files[0]]);
    var reader = new FileReader();
    reader.onload = function (event) {
      var attach = [];
      renderAttach.map(x => {
        attach.push(x)
      });
      let result;
      if(event.target.result.includes("image/png")){
        result = event.target.result.replace('data:image/png;base64,', '');
      }
      else if(event.target.result.includes("image/jpg")){
        result = event.target.result.replace('data:image/jpg;base64,', '');
      }
      else if(event.target.result.includes("image/jpeg")){
        result = event.target.result.replace('data:image/jpeg;base64,', '');
      }
      attach.push(result);
      setRenderAttach(attach);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const getExistingDefect = () => {
    setLoading(true);
    var url = `/qualitycheck/${idQualityCheck}/defects/${idDefectForQC}`;
    axios
      .get(url)
      .then((response) => {
        setLoading(false);
        var location = "";
        var subloc = "";
        var problem = "";
        var resp = "";
        response.data.attributesList.map((defect) => {
          if (defect.label == "Location") {
            location = defect.idAttribute;
          } else if (defect.label == "Subloc") {
            subloc = defect.idAttribute;
          } else if (defect.label == "Problem") {
            problem = defect.idAttribute;
          } else if (defect.label == "Responsability") {
            resp = defect.idAttribute;
          }
        });
        setExistingNote(response.data.note);
        setExistingLocation(location);
        setExistingSublocation(subloc);
        setExistingProblem(problem);
        setExistingResponsibility(resp);

        var existingImages = [];
        response.data.hashList.map((x) => {
          existingImages.push(x);
        });
        setExistingAttach(existingImages);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  function getExistingDefectThumbnail(hash) {
    setLoading(true);
    return axios
      .get(
        `/qualitycheck/${idQualityCheck}/defects/${idDefectForQC}/thumbnails/${hash}`,
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        setLoading(false);
        var base64 = Buffer.from(response.data).toString("base64");
        return base64;
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  }

  const editExistingDefect = () => {
    setLoading(true);
    let data = {
      idAttribute: responsibility,
      notes: note,
    };

    let url = `/qualitycheck/${idDefectForQC}/defects`;
    axios
      .put(url, data)
      .then(() => {
        setLoading(false);
        var files = uploadImages;
        if (files.length != 0) {
          files.map((file) => {
            handleUploadPhoto(idDefectForQC, file);
          });
        } else {
          toast.success("Saved!");
          navigateToQcItem();
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const navigateToQcItem = () => {
    dispatch(
      setBackFromDefect({
        backFromDefect: true,
      })
    );

    var url = `${process.env.PUBLIC_URL}/QCItem/${idReturnFileHead}/${idArticle}`;
    if (isEdit) {
      url += "/" + boxBarcode;
    }
    navigate(url);
  };

  const handlePhotoTakenAction = (dataUri) => {
    var file = dataURLtoFile(dataUri, "aa.png");
    var alreadyUploadedImages = []
    uploadImages.map(x => alreadyUploadedImages.push(x))
    alreadyUploadedImages.push(file);
    setUploadImages(alreadyUploadedImages);
    
    var base64 = dataUri.replace('data:image/png;base64,', '');
    var attach = [];
    renderAttach.map(x => {
      attach.push(x)
    });
    attach.push(base64);
    setRenderAttach(attach);
    setShowTakePhoto(false);
  }

  const handleExitShootPhoto = () => {
    setShowTakePhoto(false);
  }

  const handleChangeDefectData = (idDefect, level) => {
    if(level == 'location'){
      setLocation(idDefect);
      setSublocation('');
      setProblem('');
      setResponsibility('');
    }
    else if(level == 'sublocation'){
      setSublocation(idDefect);
      setProblem('');
      setResponsibility('');
    }
    else if(level == 'problem'){
      setProblem(idDefect);
      setResponsibility('');
    }
    else if(level == 'responsibility'){
      setResponsibility(idDefect);
    }    
  }

  return (
    <div>      
      {
        showTakePhoto ? 
        <ShootPhoto photoTakenAction={handlePhotoTakenAction} exitShootPhoto={handleExitShootPhoto} />
        :
        <Grid container>
          <Grid item xs={12}>
            <div id="QCheader">
              <QCDataHeader
                article={returnFileByArticle?.articleInfo}
                head={returnFileByArticle?.returnFileHeadInfo}
                quantity={returnFileByArticle?.quantity}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={4.5} lg={4.5} mt={1.2} id="articleAndPhoto">
            <div id="articleInfos">
              <Grid container ml={1}>
                <Grid item xs={1.8} sm={1.5} md={2.5} lg={1.8}>
                  <Typography className="apeDarkGreyColor">
                    {intl.formatMessage({ id: "Article.Model" })}
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2}>
                  <Typography>
                    {returnFileByArticle?.articleInfo?.styleCode}
                  </Typography>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1.8} sm={1.5} md={2.5} lg={1.8}>
                  <Typography className="apeDarkGreyColor">
                    {intl.formatMessage({ id: "Article.Part" })}
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2}>
                  <Typography>
                    {returnFileByArticle?.articleInfo?.fabricCode}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container ml={1}>
                <Grid item xs={1.8} sm={1.5} md={2.5} lg={1.8}>
                  <Typography className="apeDarkGreyColor">
                    {intl.formatMessage({ id: "Article.Color" })}
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2}>
                  <Typography>
                    {returnFileByArticle?.articleInfo?.colorCode}
                  </Typography>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1.8} sm={1.5} md={2.5} lg={1.8}>
                  <Typography className="apeDarkGreyColor">
                    {intl.formatMessage({ id: "Article.Size" })}
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2}>
                  <Typography>{returnFileByArticle?.articleInfo?.size}</Typography>
                </Grid>
              </Grid>
              <Grid container ml={1}>
                <Grid item xs={12}>
                  <Typography>
                    {returnFileByArticle?.articleInfo?.articleDescription}
                  </Typography>
                </Grid>
              </Grid>
            </div>
            {sketch !== "" ? (
              <img id="qcDefectImage" src={`data:;base64,${sketch}`} alt="sketch" style={{maxHeight: `${imageMaxHeigth}px`}} />
              ) : (
              <img id="qcDefectImage" src={require("../../img/no_image.png")} alt="NoImage" style={{maxHeight: `${imageMaxHeigth}px`}} />
            )}
          </Grid>
          <Grid item xs={7.5} mt={1.2}>
            <div style={{ border: "1px solid white" }}>
              <Typography
                variant="h5"
                sx={{ color: "grey", p: 0.5, borderBottom: "3px solid grey" }}
              >
                {intl.formatMessage({ id: "QC.NewDefect" })}
              </Typography>
              <CustomInput
                labelText={intl.formatMessage({ id: "QC.Location" })}
                type="select"
                valueRef={location}
                selectItems={locationLevelDefects}
                setValue={(e) => {handleChangeDefectData(e, 'location')}}
                textCol={2}
                inputCol={10}
              />
              {location.length != 0 ? (
                <CustomInput
                  labelText={intl.formatMessage({ id: "QC.Sublocation" })}
                  type="select"
                  valueRef={sublocation}
                  selectItems={sublocationLevelDefects}
                  setValue={(e) => {handleChangeDefectData(e, 'sublocation')}}
                  textCol={2}
                  inputCol={10}
                />
              ) : (
                ""
              )}
              {sublocation.length != 0 ? (
                <CustomInput
                  labelText={intl.formatMessage({ id: "QC.Problem" })}
                  type="select"
                  valueRef={problem}
                  selectItems={problemLevelDefects}
                  setValue={(e) => {handleChangeDefectData(e, 'problem')}}
                  textCol={2}
                  inputCol={10}
                />
              ) : (
                ""
              )}
              {problem.length != 0 ? (
                <CustomInput
                  labelText={intl.formatMessage({ id: "QC.Responsibility" })}
                  type="select"
                  valueRef={responsibility}
                  selectItems={responsibilityLevelDefects}
                  setValue={(e) => {handleChangeDefectData(e, 'responsibility')}}
                  textCol={2}
                  inputCol={10}
                />
              ) : (
                ""
              )}
              <CustomInput
                labelText={intl.formatMessage({ id: "QC.Note" })}
                type="multiline"
                value={note}
                setValue={setNote}
                textCol={2}
                inputCol={10}
                rows={4}
                defaultValue={existingNote}
              />
              <Grid container>
                <Grid item xs={2}>
                  <FormLabel sx={{ ml: 1, mr: 9 }}>
                    {intl.formatMessage({ id: "QC.Picture" })}
                  </FormLabel>
                </Grid>
                <Grid item xs={10}>
                  <Grid container xs={12}>
                  {
                    renderAttach?.map((x, i) => {
                      return (
                        <Grid item xs={2.1} id="uploadedPhotos">
                          <img src={`data:;base64,${x}`} width={100} height={100} key={x}/>
                        </Grid>
                      );
                    })
                  }
                  <Grid item xs={2}>
                    <IconButton sx={{ pl: 0 }} 
                      onClick={(e) => { e.preventDefault(); setShowTakePhoto(true)} }
                    >
                      <CameraAltOutlinedIcon
                        sx={{
                          fontSize: 100,
                          color: "white",
                          backgroundColor: "#007cd6",
                        }}
                      />
                    </IconButton>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      component="label"
                      tabIndex={-1}
                      startIcon={
                        <AddPhotoAlternateOutlinedIcon
                          style={{
                            fontSize: 100,
                            color: "white",
                            backgroundColor: "#007cd6",
                          }}
                        />
                      }
                    >
                      <input
                        type="file"
                        multiple
                        onInput={onSelectFile}
                        id="getimage"
                        accept="image/png, image/jpeg, image/jpg"
                      ></input>
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>  
          </div>
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="flex-end" id="backAndSaveButtons">
            <div>
              <Button
                variant="outlined"
                className="apeBlueColor"
                onClick={() => {navigateToQcItem()}}
              >
                {intl.formatMessage({ id: "QC.Back" })}
              </Button>
              {idDefectForQC != null ? (
                <Button
                  variant="outlined"
                  className="apeBlueColor"
                  sx={{ ml: 2 }}
                  disabled={
                    !(
                      location.length != 0 &&
                      sublocation.length != 0 &&
                      problem.length != 0 &&
                      responsibility.length != 0
                    )
                  }
                  onClick={editExistingDefect}
                >
                  {intl.formatMessage({ id: "QC.Edit" })}
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  className="apeBlueColor"
                  sx={{ ml: 2 }}
                  disabled={
                    !(
                      location.length != 0 &&
                      sublocation.length != 0 &&
                      problem.length != 0 &&
                      responsibility.length != 0
                    )
                  }
                  onClick={handleSaveDefect}
                >
                  {intl.formatMessage({ id: "QC.Save" })}
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      } 
    </div>    
  );
}
